<template>
  <div>

    <form role="form">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Evolution du nombre de membre par mois</h3>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div style="">
                <LineChartjs
                  v-if="!loadingStats"
                  :chartdata="chartdataEvolution"
                  :options="chartdataEvolution.options"
                  :style="{maxHeight: '500px',height:'500px',position: 'relative'}"
                ></LineChartjs>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Répartition homme/femme
<!--                <b-form-select v-model="anneeGenre" :options="getAllAnneesLicences()"></b-form-select>-->
              </h3>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div style="">
                <PieChartjs
                  v-if="!loadingStats"
                  :chartdata="chartdataGenres"
                  :options="chartdataGenres.options"
                  :style="{maxHeight: '500px',height:'500px',position: 'relative'}"
                ></PieChartjs>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Pourcentage Nouveau/Réaffiliation</h3>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div style="">
                <PieChartjs
                  v-if="!loadingStats"
                  :chartdata="chartdataNewReaf"
                  :options="chartdataNewReaf.options"
                  :style="{maxHeight: '500px',height:'500px',position: 'relative'}"
                ></PieChartjs>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Pyramide des âges</h3>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div style="">
                <BarChartJs
                  v-if="!loadingStats"
                  :chartdata="chartdataPyramid"
                  :options="chartdataPyramid.options"
                  :style="{maxHeight: '500px',height:'500px',position: 'relative'}"
                ></BarChartJs>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Datepicker from 'vuejs-datepicker';
    import LineChartjs from "../../Outils/LineChartjs";
    import PieChartjs from "../../Outils/PieChartjs";
    import BarChartJs from "../../Outils/BarChartjs";

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('lodash')
    var moment = require('moment')

    export default {
        data() {
            return {
                loading: {},
                dataTableRankingMember: null,
                sortBy: null,
                sortDesc: null,
                colors: ['#ffb91d', '#f97817', '#6de304', '#ff0000', '#732bea', '#c913ad',
                    '#e32d91', '#4ea6dc', '#4775e7', '#8971e1', '#d54773', '#c830cc'
                ],
                arrayEdits: [],
                isBusy: false,
                loadingStats: false,
                stats: null,
                anneeGenre: null,
                chartdataEvolution: {
                    options: {
                        maintainAspectRatio: false
                    },
                    datasets: []
                },
                chartdataGenres: {
                    options: {
                        maintainAspectRatio: false,

                    },
                    datasets: []
                },
                chartdataNewReaf: {
                    options: {
                        maintainAspectRatio: false
                    },
                    datasets: []
                },
                chartdataPyramid: {
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        maintainAspectRatio: false
                    },
                    datasets: []
                },
            }
        },
        computed: {
            ...mapGetters({
                getClub: 'getClub',
                getRoute: 'getRoute',
            }),

        },
        mounted() {
            this.getStatsClub();
            this.anneeGenre = this.getAllAnneesLicences[0] ? this.getAllAnneesLicences[0] : moment().format('YYYY')
        },
        created() {
        },
        watch: {},
        components: {
            LineChartjs,
            PieChartjs,
            BarChartJs
        },
        methods: {
            ...mapActions({}),
            getAllAnneesLicences: function () {
                let monthsShorts = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Juil', 'Aou', 'Sept', 'Oct', 'Nov', 'Dec']
                return this.getClub.licences.map((item) => {
                    return monthsShorts.forEach((month) => {
                        return month + ' ' + item.annee
                    })
                })
            },
            getCurrentDate: function (yearsToSubstract = 0) {
                return moment().subtract(yearsToSubstract, 'years').format('DD/MM/YYYY')
            },
            getMonthFrench: function (monthNumber, monthsShort = false) {
                let months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
                let monthsShorts = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Juil', 'Aou', 'Sept', 'Oct', 'Nov', 'Dec']
                return monthsShort ? monthsShorts[monthNumber - 1] : months[monthNumber - 1]
            },
            getAgeLabels: function (ages) {
                let retour = [];
                for (let i = 0; i <= 120; i++) {
                    ages.forEach((age) => {
                        if (+age == i)
                            retour.push(i + ' ans');
                    })
                }
                return retour
            },
            getDate: function (today = false) {
                return today ? moment().format('DD/MM/YYYY') : moment().year()
            },
            hexToRGB: function (hex, alpha) {
                let r = parseInt(hex.slice(1, 3), 16),
                    g = parseInt(hex.slice(3, 5), 16),
                    b = parseInt(hex.slice(5, 7), 16);

                if (alpha) {
                    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
                } else {
                    return "rgb(" + r + ", " + g + ", " + b + ")";
                }
            },
            getColor: function (colors = null) {
                let color = "#000";
                if (!colors) {
                    color = this.colors[0];
                    this.colors.shift();
                } else {
                    color = colors[0];
                    colors.shift();
                }
                return color;
            },
            setChartDataEvolution: function () {
                let cloneColors = _.clone(this.colors);
                let cloneColors2 = _.clone(this.colors);
                this.chartdataEvolution.labels = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']


                _.forEach(this.stats, (year, indexYear, array) => {
                    let labelsArray = indexYear;
                    let datasArray = [];
                    _.forEach(year, (dataMonth, indexMonth, array2) => {
                        // labelsArray.push(this.getMonthFrench(indexMonth, true) + ' ' + indexYear)
                        // labelsArray.push(indexYear)
                        datasArray.push(dataMonth['total'])
                        if (indexYear == moment().format('YYYY') && indexMonth == moment().format('M')) {
                            let labelsGenre = ['Hommes', 'Femmes']
                            let dataGenre = [dataMonth['mens'], dataMonth['womens']]
                            let labelsNewReaf = ['Nouveaux', 'Renouvellements']
                            let dataNewReaf = [dataMonth['new'], dataMonth['reaff']]
                            let dataPyramid = dataMonth['ages']
                            let keysOfDataPyramid = _.keys(dataMonth['ages']).map(function (item) {
                                return +item;
                            });
                            let dataPyramidWithAll = []
                            let labelPyramidWithAll = []
                            for (let i = 0; i <= Math.max(...keysOfDataPyramid); i++) {
                                labelPyramidWithAll.push(i + ' ans')
                                _.forEach(dataPyramid, (total, age) => {
                                    if (!dataPyramidWithAll[age])
                                        dataPyramidWithAll[age] = 0
                                    if (age == i)
                                        dataPyramidWithAll[age] = total
                                })
                            }
                            //On supprime le 0 ans
                            labelPyramidWithAll.shift()
                            dataPyramidWithAll.shift()
                            // console.log(dataPyramidWithAll);
                            this.chartdataGenres.labels = labelsGenre
                            this.chartdataGenres.datasets.push({
                                data: dataGenre,
                                backgroundColor: [
                                    "#7f78d2",
                                    "#efb1ff",
                                ]
                            })

                            this.chartdataNewReaf.labels = labelsNewReaf
                            this.chartdataNewReaf.datasets.push({
                                data: dataNewReaf,
                                backgroundColor: [
                                    "#0f4c75",
                                    "#3282b8",
                                ]
                            })

                            this.chartdataPyramid.datasets.push({
                                label: "Total",
                                minBarLength: 1,
                                // borderColor: this.hexToRGB(this.getColor(cloneColors), 1),
                                backgroundColor: "#66b5f0",
                                data: dataPyramidWithAll,
                            })
                            // this.chartdataPyramid.labels = this.getAgeLabels(_.keys(dataPyramid))
                            this.chartdataPyramid.labels = labelPyramidWithAll
                        }
                    })

                    this.chartdataEvolution.datasets.push({
                        label: labelsArray,
                        borderColor: this.hexToRGB(this.getColor(cloneColors), 1),
                        backgroundColor: this.hexToRGB(this.getColor(cloneColors2), 0.1),
                        data: datasArray,
                    })


                })
                return true
            },
            getStatsClub: async function (force = false) {
                this.loadingStats = true
                await this.$http.post(this.getRoute('getStatistiquesForClub'), {
                    id_club: this.getClub.id
                }).then((response) => {
                    this.stats = response.body
                    if (this.setChartDataEvolution())
                        this.loadingStats = false
                }, (response) => {
                });
            },

        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/Statistiques.vue